<template>
  <div class="middle-container">
    <CallUs></CallUs>
    <PersonalDetails></PersonalDetails>
    <LanguageDetails></LanguageDetails>
    <UnionDetails></UnionDetails>
    <EducationDetails></EducationDetails>
    <WorkplaceDetails v-if="subscriptionType != 'student'"></WorkplaceDetails>
    <UnemploymentInsuranceFund v-if="insurancePicked"></UnemploymentInsuranceFund>
    <ConsentSection></ConsentSection>
    <PaymentDetails></PaymentDetails>
    <SubmitForm @submit="submit"></SubmitForm>
    <LoadingSpinner></LoadingSpinner>
    <FormModal></FormModal>
  </div>
</template>

<script>
import PersonalDetails from "./FormSections/PersonalDetails.vue";
import LanguageDetails from "./FormSections/LanguageDetails.vue";
import UnemploymentInsuranceFund from "./FormSections/UnemploymentInsurance.vue";
import UnionDetails from "./FormSections/UnionDetails.vue";
import EducationDetails from "./FormSections/EducationDetails.vue";
import WorkplaceDetails from "./FormSections/WorkplaceDetails.vue";
import useVuelidate from "@vuelidate/core";
// import DropDownWithSearch from './FormComponents/DropDownWithSearch.vue'
import CallUs from "./FormComponents/CallUs.vue";
import ConsentSection from "./FormSections/ConsentSection.vue";
import PaymentDetails from "./FormSections/PaymentDetails.vue";
import SubmitForm from "./FormSections/SubmitForm.vue";
import submitForm from "./../util/submit";
import LoadingSpinner from "./FormComponents/LoadingSpinner.vue";
import FormModal from "./FormSections/FormModal.vue";
export default {
  components: {
    PersonalDetails,
    LanguageDetails,
    UnemploymentInsuranceFund,
    UnionDetails,
    EducationDetails,
    WorkplaceDetails,
    PaymentDetails,
    SubmitForm,
    CallUs,
    ConsentSection,
    LoadingSpinner,
    FormModal,
  },
  data: function (instance) {
    return {
      insurancePicked:
        instance.store[instance.store.currentCulture].values.productDetails
          .unemploymentinsuranceselected,
      subscriptionType: instance.store.subscriptionType,
      visuals: instance.store[instance.store.currentCulture].values.visualDetails,
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  mounted() {
    this.emitter.on("insurance-change", (e) => {
      this.insurancePicked = e;
    });
  },
  methods: {
    async submit() {
      // CHECK IF VALID
      const isValid = await this.v$.$validate();

      if (isValid) {
        this.visuals.showLoadingSpinner = true;
        this.visuals.disableSubmit = true;
        const result = await submitForm(this.store);
        this.visuals.showLoadingSpinner = false;
        this.visuals.disableSubmit = false;

        if (!result) {
          this.visuals.showModal = true;
        }
        else {
          window.location = result.data.redirectUrl;
        }

      } else {
        // SCROLL TO FIRST ERROR (BASED ON DIVS)
        var invalidFields = document.querySelectorAll(`.error-msg`);
        if (invalidFields && invalidFields.length > 0) {
          invalidFields[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        if (window.appInsights) {
          window.appInsights.trackEvent({ name: '(SIGNUP) (VUE) FormSubmitError', properties: { errors: this.v$.$errors } });
        }
      }
      this.visuals.showLoadingSpinner = false;
    },
  },
};

</script>
<style lang="postcss" scoped>
.middle-container {
  padding: 20px;
}
</style>

<style lang="postcss">
:root {
  --letter-spacing: 0.02em;
}

.member-signup {
  margin-bottom: 35px !important;
}
</style>
